import { generateHTML } from "@tiptap/html";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import Link from "@tiptap/extension-link";
import TextAlign from "@tiptap/extension-text-align";
import { withButtonAttrs } from "./emailButton";

const extensions = [
  StarterKit,
  TextAlign.configure({ types: ["paragraph", "heading"] }),
  Underline,
  withButtonAttrs(Link),
];

const SAMPLE_DATA = {
  firstName: "Jane",
  lastName: "Doe",
  email: "jane.doe@example.com",
  eventName: "Test",
  workspaceName: "Acme",
  claimCode: "ABCD-2345",
  claimLink: "https://app.congrs.com/open/claim/ABCD2345",
};

const replacePlaceholders = (text) => {
  if (!text) return text;
  return text
    .replace(/\{\{\s*firstName\s*\}\}/g, SAMPLE_DATA.firstName)
    .replace(/\{\{\s*lastName\s*\}\}/g, SAMPLE_DATA.lastName)
    .replace(/\{\{\s*email\s*\}\}/g, SAMPLE_DATA.email)
    .replace(/\{\{\s*eventName\s*\}\}/g, SAMPLE_DATA.eventName)
    .replace(/\{\{\s*workspaceName\s*\}\}/g, SAMPLE_DATA.workspaceName)
    .replace(/\{\{\s*claimCode\s*\}\}/g, SAMPLE_DATA.claimCode)
    .replace(/\{\{\s*claimLink\s*\}\}/g, SAMPLE_DATA.claimLink);
};

const renderContentToHtml = (content) => {
  if (!content) {
    return '<p style="color: #999; text-align: center; font-family: Arial, sans-serif;">No content yet</p>';
  }

  try {
    const json = typeof content === "string" ? JSON.parse(content) : content;
    const html = generateHTML(json, extensions);
    return `<div style="font-family: Arial, sans-serif; font-size: 15px; line-height: 1.6; color: #333333;">${replacePlaceholders(html)}</div>`;
  } catch {
    if (typeof content === "string" && content.trim()) {
      return `<div style="font-family: Arial, sans-serif; font-size: 15px; line-height: 1.6; color: #333333;">${replacePlaceholders(content)}</div>`;
    }
    return '<p style="color: #999; text-align: center; font-family: Arial, sans-serif;">No content yet</p>';
  }
};

export default renderContentToHtml;
